@if (isDataLoaded$ | async) {
  <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
      <div fxFlex>Configure Device: {{ deviceModelTitle }} Buttons</div>
      <button mat-icon-button [mat-dialog-close]="false" class="button-40">
        <mat-icon>close</mat-icon>
      </button>
    </h1>
    <mat-dialog-content style="display: flex; align-items: stretch; justify-content: center">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between"
        fxLayoutGap="20px"
        fxFlexFill
        fxLayout.sm="column"
        fxLayout.xs="column"
      >
        <div fxFlex="50" fxFlex.sm="100">
          @switch (selectedDeviceModel) {
            @case ('phone') {
              @if (isDefaultDevice) {
                <div style="display: flex; justify-content: center; position: sticky">
                  <p>Template for device: "{{ deviceModelTitle }}" not available</p>
                </div>
              } @else {
                <ng-content></ng-content>
              }
            }

            @case ('yealink-exp43') {
              <app-yealink-exp43 #expansionModule></app-yealink-exp43>
            }

            @case ('polycom-vvx-color') {
              <app-polycom-vvx-color #expansionModule></app-polycom-vvx-color>
            }

            @case ('polycom-vvx-em') {
              <app-polycom-vvx-em #expansionModule></app-polycom-vvx-em>
            }

            @case ('polycom-vvx-em50') {
              <app-polycom-vvx-em50 #expansionModule></app-polycom-vvx-em50>
            }
          }
        </div>

        <div fxFlex="50" fxFlex.sm="100" fxLayout="column" style="height: 100%; min-height: 0">
          <div style="margin-bottom: 10px" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="90">
              @for (item of selectableDevices; track $index) {
                <button
                  style="margin: 5px"
                  mat-raised-button
                  [color]="selectedDeviceId === item.id ? 'primary' : ''"
                  (click)="onDeviceSwitch(item.id)"
                >
                  {{ item.text }}
                </button>
              }
            </div>

            <div fxLayout="row">
              @if (isExpansionMode) {
                <button matTooltip="Remove Expansion" mat-icon-button color="warn" (click)="onRemoveExpansion()">
                  <mat-icon>delete</mat-icon>
                </button>
              }

              <div [matTooltip]="canAddExpansion ? 'Add Expansion' : 'Can Add Up To 3 Expansions'">
                <button mat-icon-button [matMenuTriggerFor]="menu" color="primary" [disabled]="!canAddExpansion">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <mat-menu #menu="matMenu">
              @for (item of expansionOptions; track $index) {
                <button mat-menu-item (click)="onAddExpansion(item)">
                  {{ item.text }}
                </button>
              }
            </mat-menu>
          </div>

          @if (isPagingAvailable) {
            <div class="paginator" style="display: flex; align-items: center; justify-content: flex-end">
              <button mat-icon-button (click)="onButtonsPageChange(activePage - 1)" [disabled]="activePage === 0">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span fxLayout style="margin: 0 8px; font-weight: bold">Page {{ activePage + 1 }} of {{ pageCount }}</span>
              <button mat-icon-button (click)="onButtonsPageChange(activePage + 1)" [disabled]="activePage === pageCount - 1">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }

          <!-- SCROLLABLE button area -->
          <div style="flex: 1; overflow-y: auto; min-height: 0; margin-bottom: 10px; padding: 1px">
            <mat-accordion>
              @for (buttonGroup of paginatedButtons; track buttonGroup; let i = $index) {
                <app-device-button
                  [buttonForm]="buttonGroup"
                  [formSubmitted]="formSubmitted$ | async"
                  [btnIndex]="i"
                  (expansionOpened)="onExpansionToggle(i, true)"
                  (expansionClosed)="onExpansionToggle(i, false)"
                ></app-device-button>
              }
            </mat-accordion>
          </div>

          <!-- Action buttons (fixed bottom) -->
          <div mat-dialog-actions style="padding: 0px; margin-top: 10px">
            <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100" fxLayoutGap="8px" style="width: 100%">
              <!-- Left Buttons -->
              <div fxLayout="row" fxLayoutGap="8px">
                <button
                  type="button"
                  mat-raised-button
                  color="warn"
                  style="width: 100%"
                  [disabled]="formSubmitted$ | async"
                  (click)="onButtonsClear()"
                >
                  Clear All
                </button>

                <button
                  type="button"
                  style="width: 100%"
                  mat-raised-button
                  color="primary"
                  [matMenuTriggerFor]="templateActionsMenu"
                >
                  Templates
                  <mat-menu #templateActionsMenu="matMenu">
                    <button
                      mat-menu-item
                      type="button"
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      (click)="onManageTemplates()"
                    >
                      <mat-icon>add</mat-icon>
                      Add Template
                    </button>
                    <button
                      mat-menu-item
                      type="button"
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      (click)="onSaveAsTemplate()"
                    >
                      <mat-icon>save</mat-icon>
                      Save As Template
                    </button>
                  </mat-menu>
                </button>
              </div>

              <!-- Right Buttons -->
              <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="8px">
                <button
                  type="button"
                  mat-raised-button
                  color="primary"
                  [disabled]="!isFormValid || (formSubmitted$ | async)"
                  [promiseBtn]="formSubmitted$ | async"
                  (click)="onSave()"
                >
                  Save
                </button>
                <button type="button" mat-stroked-button [mat-dialog-close]="false">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>
} @else {
  <div fxLayout="column" fxFlexFill class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
